// LanguageSwitcher.tsx

import { useState, useRef, useEffect } from "react";
import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";

const langs = [
  { code: "ka", label: "ქართული", flag: "ge" },
  { code: "en", label: "English", flag: "gb" },
  { code: "ru", label: "Русский", flag: "ru" },
] as const;

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const [open, setOpen] = useState(false);

  const ref = useRef<HTMLDivElement>(null);

  const current =
    langs.find((l) => l.code === i18n.language) || langs[0];

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, []);

  return (
    <div className="relative" ref={ref}>

      {/* BUTTON */}
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 sm:gap-4 rounded-full border-2 border-blue-600 bg-white px-3 sm:px-6 py-2 sm:py-3 shadow-sm transition-all hover:shadow-md"
      >
        <span className="text-sm sm:text-[1rem] font-black uppercase tracking-wide text-slate-700">
          {current.code}
        </span>

        <Globe
          size={22}
          className="text-slate-400 sm:w-[26px] sm:h-[26px]"
          strokeWidth={2.2}
        />
      </button>

      {/* DROPDOWN */}
      <div
        className={`absolute right-0 mt-4 sm:mt-5 w-[240px] sm:w-[300px] rounded-[24px] sm:rounded-[32px] border border-slate-100 bg-white p-3 sm:p-4 shadow-xl transition-all duration-300 z-50
          ${
            open
              ? "visible translate-y-0 opacity-100"
              : "invisible -translate-y-2 opacity-0"
          }
        `}
      >
        <div className="flex flex-col">

          {langs.map((l) => (
            <button
              key={l.code}
              onClick={() => {
                i18n.changeLanguage(l.code);
                setOpen(false);
              }}
              className={`flex items-center gap-4 sm:gap-5 rounded-2xl px-4 sm:px-5 py-4 sm:py-5 text-left transition-all
                ${
                  i18n.language === l.code
                    ? "bg-slate-50"
                    : "hover:bg-slate-50"
                }
              `}
            >
              <div className="w-10 sm:w-12 flex items-center justify-center">
              <img
                src={`https://flagcdn.com/w40/${l.flag}.png`}
                className="h-6 sm:h-8 w-auto rounded-sm"
                alt={`${l.code} flag`}
              />
            </div>

              <span className="text-base sm:text-[1rem] font-extrabold text-slate-700">
                {l.label}
              </span>
            </button>
          ))}

        </div>
      </div>
    </div>
  );
}